import React from 'react';
import { styled, Toolbar } from '@mui/material';
import { TENANT } from 'new/tenants';
const { pngLogo } = TENANT.logos;
import { boxShadow } from 'new/constants/styles';

export const TOPBAR_HEIGHT = 87;
export const BREADCRUMBS_HEIGHT = 52;

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  height: TOPBAR_HEIGHT,
  backgroundColor: theme.palette.primary.dark,
  alignItems: 'center',
  boxShadow,
}));

const EnrollHeader = () => {
  return (
    <StyledToolbar>
      <img width={200} src={pngLogo} alt="logo" />
    </StyledToolbar>
  );
};

export default EnrollHeader;
